import qs from "qs";
import axios from "axios";
import { API_URL } from "../../../constants/Constants";

/**
 * Extrae páginas de un PDF basándose en una referencia
 * @param {string} pdfUrl - URL del PDF completo
 * @param {string} referencia - Referencia a buscar (ej: "E9953")
 * @returns {Promise<string|false>} Nombre del PDF extraído (sin extensión) o false si hay error
 */
export const extractPdfByReference = async (pdfUrl, referencia) => {
  const queryData = {
    screen: "pdf_extractor",
    action: "extract_by_reference",
    url: pdfUrl,
    referencia: referencia,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));

    // El servidor devuelve status: "Success" y filename dentro de data
    if (response.data.status === "Success" || response.data.status === "ok") {
      // El servidor devuelve el nombre del PDF extraído (ya viene con extensión .pdf)
      const filename = response.data.filename || response.data.data?.filename || response.data.data;
      return typeof filename === "string" ? filename : false;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error al extraer PDF por referencia:", error);
    return false;
  }
};

